import { CALL_API } from "../middlewares/apiService";
import {
  OnSuccess,
  OnFailure,
  StoreCategory,
  AsyncTypes as Types,
  APIMiddlewareAction,
} from "../types";
import { category } from "../schema";

function fetchCategories(
  endpoint: string,
  onSuccess?: OnSuccess,
  onFailure?: OnFailure
): APIMiddlewareAction {
  return {
    name: "categories",
    // this is managed by apiService middleware
    [CALL_API]: {
      endpoint: endpoint,
      schema: { data: [category] },
      types: [
        Types.GET_ITEMS_REQUEST,
        Types.GET_ITEMS_SUCCESS,
        Types.GET_ITEMS_FAILURE,
      ],
      onSuccess,
      onFailure,
    },
  };
}

export function loadCategories(
  page = 1,
  endpoint?: string,
  onSuccess?: OnSuccess,
  onFailure?: OnFailure
) {
  return (dispatch: any, getState: any) => {
    const { pages, currPage } = getState().categories;
    // don't make pointless requests
    if (pages[page] !== undefined) {
      // keep track of the current page (useful for adding and deleting items)
      if (currPage !== page) {
        dispatch({
          type: Types.CHG_CURR_PAGE,
          name: "categories",
          page,
        });
      }
    } else {
      endpoint = `${endpoint || "/admin/categories"}?page=${page}`;
      dispatch(fetchCategories(endpoint, onSuccess, onFailure));
    }
  };
}

export function storeCategory(
  data: StoreCategory,
  onSuccess?: OnSuccess,
  onFailure?: OnFailure
): APIMiddlewareAction {
  return {
    name: "categories",
    [CALL_API]: {
      endpoint: "/admin/categories",
      schema: { data: category },
      types: [
        Types.POST_ITEM_REQUEST,
        Types.POST_ITEM_SUCCESS,
        Types.POST_ITEM_FAILURE,
      ],
      config: {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      },
      onSuccess,
      onFailure,
    },
  };
}

export function updateCategory(
  categoryId: number,
  data: StoreCategory,
  onSuccess?: OnSuccess,
  onFailure?: OnFailure
): APIMiddlewareAction {
  return {
    name: "categories",
    [CALL_API]: {
      endpoint: `/admin/categories/${categoryId}`,
      schema: { data: category },
      types: [
        Types.UPDATE_ITEM_REQUEST,
        Types.UPDATE_ITEM_SUCCESS,
        Types.UPDATE_ITEM_FAILURE,
      ],
      config: {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      },
      onSuccess,
      onFailure,
    },
  };
}

export function deleteCategory(
  categoryId: number,
  onSuccess?: OnSuccess,
  onFailure?: OnFailure
): APIMiddlewareAction {
  return {
    name: "categories",
    [CALL_API]: {
      endpoint: `/admin/categories/${categoryId}`,
      types: [
        Types.DELETE_ITEM_REQUEST,
        Types.DELETE_ITEM_SUCCESS,
        Types.DELETE_ITEM_FAILURE,
      ],
      config: {
        method: "DELETE",
      },
      onSuccess,
      onFailure,
    },
  };
}
